module.exports = __webpack_public_path__ + "static/media/inv-glider2.b8ef9528.svg";